import { render } from "./OffersCreate.vue?vue&type=template&id=a6a5731a&scoped=true"
import script from "./OffersCreate.vue?vue&type=script&lang=js"
export * from "./OffersCreate.vue?vue&type=script&lang=js"

import "./OffersCreate.vue?vue&type=style&index=0&id=a6a5731a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a5731a"]])

export default __exports__